import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { FloatSidebarButton } from './FloatSidebarButton';

type Props = {
  title: string;
  hint?: boolean;
};

type State = {
  active: boolean;
};

class FloatSidebar extends Component<Props, State> {
  state: State = {
    active: false
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    // eslint-disable-next-line react/no-find-dom-node
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({ active: false });
    }
  };

  openCloseSidebar = () => {
    this.setState(prevState => ({ active: !prevState.active }));
  };

  render() {
    const { active } = this.state;
    const { hint, title } = this.props;

    return (
      <div
        className={`float-sidebar ${active ? 'active' : ''}`}
        data-testid="float-sidebar-container"
      >
        <FloatSidebarButton
          icon="fa fa-cubes"
          hint={hint}
          hintMessage={title}
          onButtonClick={this.openCloseSidebar}
        />

        <div className="title">{title}</div>

        {this.props.children}
      </div>
    );
  }
}

export { FloatSidebar };
